import { formatMoney } from '@theme/money-formatting';

/**
 * Keeps the Clearpay / Klarna instalment amounts in step with the selected
 * variant.
 *
 * product-form.js only shows or hides the accelerated checkout container on a
 * variant change, it never re-renders it, so the amounts this block rendered
 * server-side would otherwise go stale as soon as a shopper picks a variant at
 * a different price.
 */
class InstalmentsSummary extends HTMLElement {
  /** @type {Element | null} */
  #scope = null;

  connectedCallback() {
    // Scope to the section (or quick-add dialog) so a second product on the
    // page cannot rewrite this one's amounts. Matches local-pickup.js.
    this.#scope = this.closest('.shopify-section, dialog');
    this.#scope?.addEventListener('variant:update', this.#onVariantUpdate);
  }

  disconnectedCallback() {
    this.#scope?.removeEventListener('variant:update', this.#onVariantUpdate);
  }

  /** @param {Event & { detail?: { resource?: { price?: number } } }} event */
  #onVariantUpdate = (event) => {
    const price = event.detail?.resource?.price;
    if (typeof price !== 'number') return;

    const format = this.dataset.moneyFormat || '{{amount}}';
    const currency = this.dataset.currency || window.Shopify?.currency?.active || 'GBP';

    for (const amount of this.querySelectorAll('[data-divisor]')) {
      if (!(amount instanceof HTMLElement)) continue;

      const divisor = Number(amount.dataset.divisor);
      if (!divisor) continue;

      // Round in minor units, the same way the Liquid does, so the first paint
      // and every later update agree.
      amount.innerHTML = formatMoney(Math.round(price / divisor), format, currency);
    }
  };
}

if (!customElements.get('instalments-summary')) {
  customElements.define('instalments-summary', InstalmentsSummary);
}
